import { useTranslation } from 'react-i18next';

export default function Reassurance() {
  const { t } = useTranslation();

  const points = [
    {
      icon: 'ri-timer-flash-line',
      title: t('reassurance.point1Title'),
      desc: t('reassurance.point1Desc'),
    },
    {
      icon: 'ri-shield-star-line',
      title: t('reassurance.point2Title'),
      desc: t('reassurance.point2Desc'),
    },
    {
      icon: 'ri-recycle-line',
      title: t('reassurance.point3Title'),
      desc: t('reassurance.point3Desc'),
    },
  ];

  return (
    <section className="py-20 bg-[#FFF9F7]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/203e83861d8ec7ce203a8e30e0d3486d.jpg"
                alt="Technicien réparant une valise premium en atelier"
                className="w-full h-[420px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-5 -right-3 lg:-right-6 bg-white rounded-2xl px-5 py-4 shadow-lg flex items-center gap-3 z-10">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#4ECDC4] to-[#38B2AC] flex items-center justify-center">
                <i className="ri-tools-line text-white text-xl"></i>
              </div>
              <div>
                <div className="text-lg font-bold text-gray-900" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  +20 000
                </div>
                <div className="text-gray-500 text-xs">{t('reassurance.badge2')}</div>
              </div>
            </div>

            {/* Decorative accent */}
            <div className="absolute -top-4 -left-4 w-24 h-24 border-2 border-[#FF6B6B]/20 rounded-3xl -z-0"></div>
          </div>

          {/* Right - Content */}
          <div>
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-[#FF6B6B]/10 rounded-full text-[#FF6B6B] text-sm font-semibold mb-5">
              <i className="ri-hand-heart-line"></i>
              {t('reassurance.badge')}
            </span>
            <h2
              className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-4"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {t('reassurance.title')}
              <span className="bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] bg-clip-text text-transparent">
                {' '}{t('reassurance.titleHighlight')}{' '}
              </span>
              {t('reassurance.titleEnd')}
            </h2>
            <p
              className="text-gray-600 mb-10 leading-relaxed text-[15px]"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {t('reassurance.description')}
            </p>

            <div className="flex flex-col gap-7">
              {points.map((point, index) => (
                <div key={index} className="flex gap-4 group">
                  <div className="w-12 h-12 min-w-[48px] rounded-xl bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className={`${point.icon} text-white text-xl`}></i>
                  </div>
                  <div>
                    <h4
                      className="font-bold text-gray-900 mb-1"
                      style={{ fontFamily: 'Poppins, sans-serif' }}
                    >
                      <a href="#services" className="hover:text-[#FF6B6B] transition-colors">
                        {point.title}
                      </a>
                    </h4>
                    <p className="text-gray-500 text-sm leading-relaxed">{point.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
